import { theme as colorsTheme } from 'lusha-ui-components-v2';

export const theme = {
  colors: colorsTheme.colors,
};
